import { render, staticRenderFns } from "./teambottom.vue?vue&type=template&id=04ca2d27&scoped=true"
import script from "./teambottom.vue?vue&type=script&lang=js"
export * from "./teambottom.vue?vue&type=script&lang=js"
import style0 from "./teambottom.vue?vue&type=style&index=0&id=04ca2d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca2d27",
  null
  
)

export default component.exports